<template>
  <nav
    class="breadcrumbs"
    aria-label="breadcrumb"
  >
    <template
      v-for="(breadcrumb, index) in breadcrumbs"
    >
      <router-link
        v-if="breadcrumb.link"
        :key="index"
        class="breadcrumbs__item"
        :to="breadcrumb.link"
      >
        {{ breadcrumb.name }}
      </router-link>
      <span
        v-else
        :key="index"
        class="breadcrumbs__item"
        aria-current="page"
      >{{ breadcrumb.name }}</span>
      <v-icon
        v-if="breadcrumb.link"
        :key="'divider' + index"
        class="breadcrumbs__divider"
        type="angle-right"
      />
    </template>
  </nav>
</template>

<script>
  import Icon from "@/atoms/Icon";

  export default {
    components: {
      "v-icon": Icon
    },
    props: {
      breadcrumbs: {
        type: Array,
        default: null
      }
    }
  };
</script>

<style lang="scss">
  @import "../../styles/shared/shared";

  .breadcrumbs {
    margin-bottom: 1rem;
    &__divider {
      color: $pigeon;
      margin-left: 1rem;
      margin-right: 1rem;
    }
    &__item {
      display: inline-block;
      vertical-align: middle;
      max-width: 14rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      @at-root a#{&} {
        color: $pigeon;
        text-decoration: none;
      }
      @at-root span#{&} {
        color: $tangaroa;
      }
    }
  }
</style>
